module.exports = __webpack_public_path__ + "static/images/styles/images/nations/poland-cn.28da6b9b.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/nations/poland-cn.png
// module id = 3669
// module chunks = 11